import { createFileRoute } from '@tanstack/react-router';
import { EcranUtilisateurs } from '../admin/utilisateurs/EcranUtilisateurs';

export const Route = createFileRoute('/admin/utilisateurs')({
  component: EcranUtilisateurs,
});
